import { getCookie } from '@/utils/cookie';

const getStatsigStableId = (): string => {
  return getCookie('statsigStableId') ?? '';
};

export default getStatsigStableId;
